import { AlertTriangle, RotateCcw } from 'lucide-react'
import { getErrorMessage } from '../../lib/errors'

interface QueryErrorStateProps {
  title?: string
  error: unknown
  onRetry: () => void
  isRefetching?: boolean
}

export function QueryErrorState({
  title = 'Error al cargar',
  error,
  onRetry,
  isRefetching = false,
}: QueryErrorStateProps) {
  const message = getErrorMessage(error)
  return (
    <div className="card py-12 text-center">
      <AlertTriangle className="w-12 h-12 text-amber-500 mx-auto mb-3" />
      <p className="text-slate-700 font-medium">{title}</p>
      <p className="text-sm text-slate-500 mt-1">{message}</p>
      <button
        type="button"
        onClick={onRetry}
        disabled={isRefetching}
        className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-slate-800 text-white rounded-lg hover:bg-slate-700 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
      >
        <RotateCcw className="w-4 h-4" />
        {isRefetching ? 'Reintentando...' : 'Reintentar'}
      </button>
    </div>
  )
}
